const DASHBOARD_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const getLondonTodayDate = () => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const isValidDashboardDate = dateValue => {
  if (typeof dateValue !== 'string' || !DASHBOARD_DATE_PATTERN.test(dateValue)) {
    return false;
  }

  const [year, month, day] = dateValue.split('-').map(Number);
  const parsedDate = new Date(Date.UTC(year, month - 1, day));
  return parsedDate.getUTCFullYear() === year
    && parsedDate.getUTCMonth() === month - 1
    && parsedDate.getUTCDate() === day;
};

export const parseDashboardRouteDate = params => {
  const date = params?.date;
  if (!isValidDashboardDate(date)) {
    return { valid: false, date: null, isToday: false, error: 'Invalid dashboard date.' };
  }

  const today = getLondonTodayDate();
  if (date > today) {
    return { valid: false, date, isToday: false, error: 'Future dashboard dates are not available.' };
  }

  return { valid: true, date, isToday: date === today, error: null };
};

export const addDashboardDays = (dateValue, days) => {
  if (!isValidDashboardDate(dateValue)) return getLondonTodayDate();
  const [year, month, day] = dateValue.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

export const buildDashboardRoute = (date = getLondonTodayDate()) => ({
  name: 'DashboardDay',
  params: { date }
});
